import tooltipImg from 'img/tooltip/family-album.png';
import React, { type FC } from 'react';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { type ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';

import styles from './FamilyTooltip.css';

interface Props {
    target: React.RefObject<HTMLElement> | null;
    title: string;
    text: string;
    buttonText: string;
    placement: ETooltipPlacement;
    usePortal?: boolean;
    onShow?: () => void;
    onClick?: () => void;
    onClose?: () => void;
    onCrossClose?: () => void;
    qaId: string;
}

export const FamilyTooltip: FC<Props> = ({
    target,
    title,
    text,
    usePortal,
    placement,
    onClick,
    onClose,
    onShow,
    onCrossClose,
    buttonText,
    qaId,
}) => {
    return (
        <FloatingTooltip
            target={target}
            placement={placement}
            size={ETooltipSize.fit}
            onClose={onClose}
            onShow={onShow}
            onCrossClose={onCrossClose}
            usePortal={usePortal}
            qaId={qaId}
        >
            <div className={styles.root}>
                <div className={styles.textBlock}>
                    <div className={styles.title} data-qa-id="family-tooltip-title">
                        {title}
                    </div>
                    <div className={styles.text} data-qa-id="family-tooltip-text">
                        {text}
                    </div>
                </div>
                <Button
                    onClick={onClick}
                    className={styles.button}
                    primary
                    theme="vk"
                    sizeMode={ButtonSizeMode.small}
                    data-qa-id="family-tooltip-button"
                >
                    {buttonText}
                </Button>
                <img className={styles.image} src={tooltipImg} alt="Картинка в тултипе" data-qa-id="family-tooltip-image" />
            </div>
        </FloatingTooltip>
    );
};
